import { useCallback } from 'react';
import Lang from '@lang/en';
import { healthCheckS3PresignedUrl } from '@app/definition/API';
import apiClient from '@app/network/apiClient';

type GetSignedUrlFunction = (
  file: File
) => Promise<{ filename: string; signedUrl: string; previewUrl: string }>;

const usePresignedUrl = (
  orderId: number
): {
  getSignedUrl: GetSignedUrlFunction;
} => {
  const getSignedUrl = useCallback(
    async (file) => {
      const params = {
        file: encodeURIComponent(file.name),
      };
      const url = healthCheckS3PresignedUrl.replace('%id%', String(orderId));
      const response = await apiClient.get(url, {
        params,
      });
      if (response.status >= 400) {
        throw new Error(response.data.message || Lang.invalidResponse);
      }

      const data = response.data.data || {};
      return {
        previewUrl: data.presignedGet,
        signedUrl: data.presignedPut,
        filename: data.filename,
      };
    },
    [orderId]
  );

  return { getSignedUrl };
};

export default usePresignedUrl;
